import { ShieldCheck, Truck, Factory, Leaf } from "lucide-react";

const features = [
  {
    icon: ShieldCheck,
    title: "Garanția calității",
    text: "Fiecare produs este testat riguros pentru eficiență maximă și siguranță în utilizare.",
  },
  {
    icon: Factory,
    title: "Fabricat în România",
    text: "Producție locală, conform standardelor europene. Sprijinim economia românească.",
  },
  {
    icon: Truck,
    title: "Transport gratuit",
    text: "La toate pachetele XXL livrăm gratuit oriunde în țară, în 24-48h.",
  },
  {
    icon: Leaf,
    title: "Formule concentrate",
    text: "Mai puțină cantitate, mai multe spălări. Economie reală pentru bugetul familiei.",
  },
];

export const Features = () => {
  return (
    <section
      id="avantaje"
      data-testid="features-section"
      className="py-20 md:py-28 bg-white/60 backdrop-blur-sm border-y border-white/60"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="max-w-2xl mb-14 md:mb-20">
          <div className="text-xs font-semibold tracking-[0.2em] uppercase text-cyan-600 mb-3">
            De ce să ne alegi
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-black tracking-tight text-slate-900 leading-tight">
            Performanță reală.<br />
            <span className="text-cyan-600">Prețuri corecte.</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((f, i) => {
            const Icon = f.icon;
            return (
              <div
                key={i}
                data-testid={`feature-card-${i}`}
                className="group relative p-7 rounded-2xl bg-sky-50 border border-sky-100 hover:bg-white hover:border-cyan-200 hover:shadow-xl hover:shadow-cyan-100/50 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-14 h-14 rounded-xl bg-white border border-cyan-100 flex items-center justify-center mb-5 group-hover:bg-cyan-600 transition-colors">
                  <Icon className="w-6 h-6 text-cyan-600 group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-heading text-lg font-bold text-slate-900 mb-2">
                  {f.title}
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed">{f.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
